module.exports = __webpack_public_path__ + "static/why-your-business-eeds-757508921c6a04a0145519c66f2c90c3.jpg";